import {
    Component,
    ElementRef,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
    ViewChild
} from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { AppStartupService, MatrixProductPrice, ProductPropertiesType } from '@ridango/core';

import { BehaviorSubject, combineLatest, Observable } from 'rxjs';

import { ProductsState } from './../../+state';
import { SelectableItemComponent } from './../../../core-ui/basic/selectable-item/selectable-item.component';

import Env from '@ridango/core/env';
import { TicketValidityFacade } from '../../../../../../services/ticket-validity-facade.service';
import { map, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'ridango-product-list-item',
    templateUrl: './product-list-item.component.html',
    styleUrls: ['./product-list-item.component.scss']
})
export class ProductListItemComponent extends SelectableItemComponent implements OnInit, OnChanges, OnDestroy {
    readonly ProductPropertiesType = ProductPropertiesType;

    private readonly jointTicketRangeTotalDays$ = this.validityFacade.jointTicketRangeTotalDays$;
    private readonly totalDaysDefaultMultiplier = 1;

    private dynamicProduct = false;
    private itemSelected$ = new BehaviorSubject<boolean>(false);

    totalDays$ = combineLatest([this.jointTicketRangeTotalDays$, this.itemSelected$]).pipe(
        takeUntil(this.componentDestroyed$),
        map(([totalDays, selected]) =>
            this.dynamicProduct && selected
                ? totalDays ?? this.totalDaysDefaultMultiplier
                : this.totalDaysDefaultMultiplier
        )
    );

    @Input() overrideNames = false;
    @Input() moneyFormat = false;
    @Input() lang = 'en';
    @Input() tabIndex = 0;

    @ViewChild('productItem') productItem: ElementRef;

    price$: Observable<MatrixProductPrice>;
    constructor(
        @Inject('ENV') public env: Env,
        private ngRedux: NgRedux<ProductsState>,
        private validityFacade: TicketValidityFacade,
        public appStartupService: AppStartupService
    ) {
        super();
    }
    ngOnInit() {
        // TODO: this is wrong
        this.price$ = this.ngRedux.select(['products', 'matrixProductPrices', this.item.product_id]);
        this.checkIfProductIsDynamic();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selected) {
            this.itemSelected$.next(changes.selected.currentValue);
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.resetDynamicState();
    }

    checkIfProductIsDynamic(): void {
        this.dynamicProduct = !!this.item?.product_properties?.find(
            (p: any) => p.code === ProductPropertiesType.DynamicLength
        );
    }

    resetDynamicState(): void {
        this.dynamicProduct = false;
        this.itemSelected$.next(false);
        this.itemSelected$.complete();
    }
}
